import React, { useEffect, useState, useMemo, useContext, useCallback } from "react"
import Header from "../../../layouts/Header"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import { PickingContext } from "../PickingContext"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import DetalleImpresion from "./DetalleImpresion"
import { useNavigate, useLocation } from "react-router-dom"
import {
  InputLabel,
  TextField,
  Button,
  IconButton,
  Modal,
  Box,
  useTheme,
  InputAdornment,
  Select,
  MenuItem,
} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useQuery, useMutation } from "@tanstack/react-query"
import Pagination from "@mui/material/Pagination"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"

import CustomFieldset from "../../../components/CustomFieldset"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import { esES } from "@mui/material/locale"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import CloseIcon from "@mui/icons-material/Close"
import Lotes from "./Lote"
import Obturador from "../../../components/Obturador/Obturador"
import CustomTooltip from "../../../components/ToolTip"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import BackIcon from "../../../components/BackIcon"
import Swal from "sweetalert2"
import useDebounce from "../../SolicitudDeIngreso/components/Debounce"
import dayjs from "dayjs"
import CustomInputInteger from "../../../components/CustomInputInteger"

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const SearchTexfield = ({ sgapickingsecuen, idProducto, value, setProducto, columnsTable, dataTable }) => {
  const styles = {
    modalStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      bgcolor: "background.paper",
      border: "2px solid #000",
      boxShadow: 24,
      p: 4,
    },
    closeStyle: {
      cursor: "pointer",
      marginLeft: "95%",
    },
  }
  const [open, setOpen] = useState(false) // modal
  const handleOpenModal = () => setOpen(true)
  const handleCloseModal = () => setOpen(false)
  return (
    <span style={{ flexGrow: 1 }}>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles.modalStyle}>
          <IconButton style={styles.closeStyle} onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
          <SingleRowSelectionTable
            columnsTable={columnsTable}
            dataTable={[...dataTable]}
            sgapickingsecuen={sgapickingsecuen}
            idProducto={idProducto}
            setProducto={setProducto}
            handleCloseModal={handleCloseModal}
          />
        </Box>
      </Modal>

      <TextField
        fullWidth
        id={`outlined-${sgapickingsecuen}-${idProducto}`}
        variant="standard"
        value={value ?? ""}
        disabled
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <IconButton onClick={handleOpenModal}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </span>
  )
}

// const IntegerInput = ({ value, setValue, style, disabled }) => {
//   const handleChange = (event) => {
//     const newValue = event.target.value.replace(/\D/g, "") // Eliminar todos los caracteres que no sean dígitos
//     setValue(newValue)
//   }
//   return (
//     <TextField
//       disabled={disabled}
//       style={style}
//       fullWidth
//       variant="outlined"
//       type="number"
//       value={value}
//       onChange={handleChange}
//     />
//   )
// }

const SingleRowSelectionTable = ({
  columnsTable,
  dataTable,
  sgapickingsecuen,
  idProducto,
  setProducto,
  handleCloseModal,
}) => {
  const theme = useTheme()
  const [rowSelection, setRowSelection] = useState({})
  const columns = useMemo(() => columnsTable)
  const data = dataTable

  const table = useMaterialReactTable({
    localization: { ...MRT_Localization_ES },
    columns,
    data,
    enableRowSelection: true,
    enableMultiRowSelection: false, // use radio buttons instead of checkboxes
    getRowId: (row) => row.bahcodigo, // give each row a more useful id
    muiTableBodyRowProps: ({ row }) => ({
      // add onClick to row to select upon clicking anywhere in the row
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
    positionToolbarAlertBanner: "bottom", // move the alert banner to the bottom
    onRowSelectionChange: setRowSelection, // connect internal row selection state to your own
    state: { rowSelection }, // pass our managed row selection state to the table to use
  })

  const handleSelectSingleRow = () => {
    try {
      let rowSelected = table.getSelectedRowModel().rows[0]
      rowSelected = rowSelected.original
      setProducto(sgapickingsecuen, idProducto, rowSelected)
    } catch (error) {
      console.log(error)
    } finally {
      handleCloseModal()
    }
  }
  return (
    <ThemeProvider theme={createTheme(theme, esES)}>
      <MaterialReactTable table={table} />
      <div style={{ clear: "both" }}>
        <Button variant="text" color="primary" style={{ float: "right" }} onClick={handleSelectSingleRow}>
          Establecer
        </Button>
      </div>
    </ThemeProvider>
  )
}

const DisabledTextField = ({ label = "", value }) => {
  return (
    <span style={{ flexGrow: 1 }}>
      <TextField fullWidth id={`outlined`} variant="standard" label={label} value={value ?? ""} disabled />
    </span>
  )
}

const CustomSelectComponent = ({ lotesData, style }) => {
  const validLotesData = Array.isArray(lotesData) ? lotesData : []
  const [selectedLote, setSelectedLote] = useState(validLotesData.length > 0 ? validLotesData[0].artlote : "")

  const handleChange = (event) => {
    setSelectedLote(event.target.value)
  }

  return (
    <div style={style}>
      <Select fullWidth value={selectedLote} onChange={handleChange}>
        {validLotesData.map((lote) => (
          <MenuItem key={lote.artlote} value={lote.artlote}>
            {`${lote.artlote} - Cant: ${lote.artcantlote} - Elab: ${normalFormatDate(lote.artfecfab)} - Vence: ${normalFormatDate(lote.artfecven)}`}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}

const CustomAccordion = ({
  productos,
  fetchedBahias,
  fetchedNiveles,
  fetchedPosiciones,
  setProducto,
  setProductoNiveles,
  setProductoPosiciones,
  setProductoI,
  setProductoNivelesI,
  setProductoPosicionesI,
  updateProduct,
  setProductosPicking,
  setProductoAumento,
}) => {
  const textIsAlreadyDecodedUbicacion = (infoRead, closeModalQr) => {
    const textDecoded = infoRead?.barcodeDataText

    if (textDecoded) {
      const [bahia, pasillo, nivel, posicion] = infoRead.barcodeDataText.split(";")

      if (
        bahia === productos?.bahcodigo &&
        pasillo === productos?.pascodigo &&
        nivel === productos?.nivcodigo &&
        posicion === productos?.poscodigo
      ) {
        const confirmacion = window.confirm("¿Desea realizar la movilización del pallet?")
        if (confirmacion) {
          closeModalQr()
          // handleSaveProductsAMovilizar()
        }
      } else {
        alert(`La ubicacion leída no coincide:\n
        Bahía: ${bahia}\n
        Pasillo: ${pasillo}\n
        Nivel: ${nivel}\n
        Posición:${posicion}\n
        `)
        closeModalQr()
      }
    } else {
      throw new Error("")
    }
  }

  const handleAumentarCantidad = async () => {
    // Validar la cantidad a aumentar
    if (cantidadAumentar <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Advertencia",
        text: "La cantidad a aumentar debe ser mayor que 0.",
      })
      return
    }

    // Mostrar confirmación antes de proceder
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Confirma que deseas aumentar la cantidad de Picking.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, actualizar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Hacer la solicitud PUT directamente
          const options = {
            method: "PUT",
            body: JSON.stringify({
              cantidadAumento: cantidadAumentar, // Asegúrate de que coincida con los nombres esperados por la API
              sgasolegr: productos.sgasolegrfac,
              sgasecuen: productos.facsecuen,
              sgapickingsecuen: productos.sgapickingsecuen,
              sgapicking: productos.sgapicking,
            }),
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }

          // Hacer la llamada a la API utilizando fetchwrapper
          const response = await fetchwrapper("/picking/aumentarCantidadPicking", options)

          // Verificar si la respuesta fue exitosa
          if (!response.ok) {
            throw new Error("Error al aumentar la cantidad")
          }

          const data = await response.json() // Obtener la respuesta JSON
          console.log(options.body)
          console.log("Datos recibidos:", data)

          setProductosPicking((prevProductosPicking) => {
            // Iteramos sobre los productos
            prevProductosPicking.forEach((producto) => {
              if (
                producto.sgapickingsecuen === productos.sgapickingsecuen &&
                producto.artcodigo === productos.artcodigo
              ) {
                // Usamos la función updateProduct para actualizar los valores
                updateProduct(
                  productos.sgapickingsecuen,
                  productos.artcodigo,
                  {
                    sgacanpicking: (parseFloat(producto.sgacanpicking) || 0) + parseFloat(cantidadAumentar), // Actualizar la cantidad a nivel de frontend
                    sgacansolfac: (parseFloat(producto.sgacansolfac) || 0) + parseFloat(cantidadAumentar), // Actualizar otro campo
                    detalleAumento: "Aumentado",
                  },
                  prevProductosPicking,
                )
              }
            })

            return [...prevProductosPicking] // Devuelve el nuevo estado
          })

          // Mostrar mensaje de éxito
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: "La solicitud ha sido actualizada correctamente.",
          })
          setDisabledAumentar(true)
        } catch (error) {
          // Mostrar mensaje de error en caso de fallo
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo un problema al actualizar los datos. Por favor intenta de nuevo.",
          })
          console.error("Error actualizando productos:", error)
        }
      }
    })
  }

  const textIsAlreadyDecodedPallet = (infoRead) => {
    const textDecoded = infoRead?.barcodeDataText

    if (textDecoded) {
      const data = {
        type: "barcodePallet",
        palletId: `PLA${textDecoded}`,
      }

      searchPallet(null, null, data)
    } else {
      throw new Error("")
    }
  }

  const isValidCodePallet = (code) => {
    const formatCode = String(code).trim()
    const codeChars = formatCode.substring(0, 3)
    const codeNums = formatCode.substring(3)

    return formatCode !== null && formatCode !== "" && codeChars === "PLA" && /^\d+$/.test(codeNums)
  }

  const searchPallet = (e, palletCode, data = {}, closeModalQr) => {
    if (e) e.preventDefault()
    const navigateData = {
      palletId: palletCode,
      ...data,
    }

    if (isValidCodePallet(navigateData?.palletId)) {
      const confirmacion = window.confirm("¿Desea realizar la movilización del pallet?")
      if (confirmacion) {
        closeModalQr()
        // handleSaveProductsAMovilizar()
      }
    } else {
      alert("Código de pallet inválido")
    }
  }

  const textIsAlreadyDecodedUbicacionIngreso = (infoRead, closeModalQr) => {
    const textDecoded = infoRead?.barcodeDataText

    if (textDecoded) {
      const [bahia, pasillo, nivel, posicion] = infoRead.barcodeDataText.split(";")

      if (
        bahia === productos?.bahias[0].izoncodigoI &&
        pasillo === productos?.bahias[0].pascodigoI &&
        nivel === productos?.nivel.nivdescripcionI &&
        posicion === productos?.posicion.posdescripcionI
      ) {
        const confirmacion = window.confirm("¿Desea realizar la movilización del pallet?")
        if (confirmacion) {
          closeModalQr()
          // handleSaveProductsAMovilizar()
        }
      } else {
        alert(`La ubicacion leída no coincide:\n
        Bahía: ${bahia}\n
        Pasillo: ${pasillo}\n
        Nivel: ${nivel}\n
        Posición:${posicion}\n
        `)
        closeModalQr()
      }
    } else {
      throw new Error("")
    }
  }

  const styles = {
    accordionSummary: {
      backgroundColor: "rgb(25, 108, 135)",
      color: "white",
      fontWeight: "bolder",
    },
    row: {
      display: "flex",
      alignItems: "center",
      paddingBlock: "10px",
    },
    rowTitle: {
      alignSelf: "end",
      paddingRight: "20px",
      fontWeight: "bolder",
    },

    rowContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "20px",
      width: "100%",
    },
  }

  const [cantidadPicking, setCantidadPicking] = useState(productos.cantidadSeleccionada)
  const [cantidadAumentar, setCantidadAumentar] = useState(0)
  const [disabledAumentar, setDisabledAumentar] = useState(productos.detalleAumento !== " ")

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${productos.artcodigo}`}
        id={productos.artcodigo}
        style={styles.accordionSummary}
      >
        {`${productos.artcodigo + " - " + productos.artdescri}`}
      </AccordionSummary>
      <AccordionDetails>
        <div style={{ marginTop: "2%" }}>
          <CustomFieldset title={"Información General"}>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Código Embalaje</span>
              <DisabledTextField value={productos.embcodigo} />
            </div>

            <div style={styles.row}>
              <span style={styles.rowTitle}>Descripción Embalaje:</span>
              <DisabledTextField value={productos.embdescripcion} />
            </div>

            <div style={styles.row}>
              <span style={styles.rowTitle}>Pieza:</span>
              <DisabledTextField value={productos.embpieza} />
            </div>

            <div style={styles.row}>
              <span style={styles.rowTitle}>m2:</span>
              <DisabledTextField value={productos.embmetros2} />
            </div>

            <div style={styles.row}>
              <span style={styles.rowTitle}>Código de Tono:</span>
              <DisabledTextField value={productos.toncodigo} />
            </div>

            <div style={styles.row}>
              <span style={styles.rowTitle}>Descripción de Tono:</span>
              <DisabledTextField value={productos.tondescripcion} />
            </div>
          </CustomFieldset>
        </div>
        <div style={{ marginTop: "2%" }}>
          <CustomFieldset title={"Ubicación"}>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Zona:</span>
              <DisabledTextField value={productos.izondescripcion} />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Bahía:</span>
              <SearchTexfield
                sgapickingsecuen={productos.sgapickingsecuen}
                idProducto={productos.artcodigo}
                value={productos.bahcodigo}
                setProducto={setProducto}
                columnsTable={[
                  {
                    accessorKey: "bahcodigo",
                    header: "Código Bahia",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "bahdescripcion",
                    header: "Descripción Bahía",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "bahmetros3",
                    header: "m3",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "izoncodigo",
                    header: "Código Zona",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "izondescripcion",
                    header: "Descripción Zona",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "pascodigo",
                    header: "Código Pasillo",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "pasdescripcion",
                    header: "Descripción Pasillo",
                    enableEditing: false,
                    size: 200,
                  },
                ]}
                dataTable={fetchedBahias}
              />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Pasillo:</span>
              <DisabledTextField value={productos.pasdescripcion} />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Nivel:</span>
              <SearchTexfield
                sgapickingsecuen={productos.sgapickingsecuen}
                idProducto={productos.artcodigo}
                value={productos.nivdescripcion}
                setProducto={setProductoNiveles}
                columnsTable={[
                  {
                    accessorKey: "nivcodigo",
                    header: "Código Nivel",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "nivdescripcion",
                    header: "Descripción Nivel",
                    enableEditing: false,
                    size: 200,
                  },
                ]}
                dataTable={fetchedNiveles}
              />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Posición:</span>
              <SearchTexfield
                sgapickingsecuen={productos.sgapickingsecuen}
                idProducto={productos.artcodigo}
                value={productos.posdescripcion}
                setProducto={setProductoPosiciones}
                columnsTable={[
                  {
                    accessorKey: "poscodigo",
                    header: "Código Posición",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "posdescripcion",
                    header: "Descripción Posición",
                    enableEditing: false,
                    size: 200,
                  },
                ]}
                dataTable={fetchedPosiciones}
              />
            </div>
            <div style={styles.rowContainer}>
              <Obturador
                scannerParams={{
                  msg: "Escanea el código de barras",
                  codeType: "bar",
                }}
                executeFunction={textIsAlreadyDecodedUbicacion}
              />
            </div>
          </CustomFieldset>
        </div>
        <div style={{ marginTop: "2%" }}>
          <CustomFieldset title={"Pallet"}>
            <div style={styles.row}>
              <span style={styles.rowTitle}>PalletID:</span>
              <DisabledTextField value={productos.palletid} />
            </div>
          </CustomFieldset>
        </div>
        {/* Ubicación Ingreso */}
        <div style={{ marginTop: "2%" }}>
          <CustomFieldset title={"Ubicación Ingreso"}>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Zona:</span>
              <DisabledTextField value={productos.bahias[0].izoncodigoI} />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Bahía:</span>
              <SearchTexfield
                sgapickingsecuen={productos.sgapickingsecuen}
                idProducto={productos.artcodigo}
                value={productos.bahias[0].bahdescripcionI}
                setProducto={setProductoI}
                columnsTable={[
                  {
                    accessorKey: "bahcodigo",
                    header: "Código Bahia",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "bahdescripcion",
                    header: "Descripción Bahía",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "bahmetros3",
                    header: "m3",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "izoncodigo",
                    header: "Código Zona",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "izondescripcion",
                    header: "Descripción Zona",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "pascodigo",
                    header: "Código Pasillo",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "pasdescripcion",
                    header: "Descripción Pasillo",
                    enableEditing: false,
                    size: 200,
                  },
                ]}
                dataTable={fetchedBahias}
              />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Pasillo:</span>
              <DisabledTextField value={productos.bahias[0].pascodigoI} />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Nivel:</span>
              <SearchTexfield
                sgapickingsecuen={productos.sgapickingsecuen}
                idProducto={productos.artcodigo}
                value={productos.nivel.nivdescripcionI}
                setProducto={setProductoNivelesI}
                columnsTable={[
                  {
                    accessorKey: "nivcodigo",
                    header: "Código Nivel",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "nivdescripcion",
                    header: "Descripción Nivel",
                    enableEditing: false,
                    size: 200,
                  },
                ]}
                dataTable={fetchedNiveles}
              />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Posición:</span>
              <SearchTexfield
                sgapickingsecuen={productos.sgapickingsecuen}
                idProducto={productos.artcodigo}
                value={productos.posicion.posdescripcionI}
                setProducto={setProductoPosicionesI}
                columnsTable={[
                  {
                    accessorKey: "poscodigo",
                    header: "Código Posición",
                    enableEditing: false,
                    size: 200,
                  },
                  {
                    accessorKey: "posdescripcion",
                    header: "Descripción Posición",
                    enableEditing: false,
                    size: 200,
                  },
                ]}
                dataTable={fetchedPosiciones}
              />
            </div>
            <div style={styles.rowContainer}>
              <Obturador
                scannerParams={{
                  msg: "Escanea el código de barras",
                  codeType: "bar",
                }}
                executeFunction={textIsAlreadyDecodedUbicacionIngreso}
              />
            </div>
          </CustomFieldset>
        </div>
        {/* Cantidad */}
        <div style={{ marginTop: "2%" }}>
          <CustomFieldset title={"Ubicación Ingreso"}>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Cantidad Solicitada:</span>
              <DisabledTextField value={productos.sgacansolfac} />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Cantidad Picking Sugerido:</span>
              <DisabledTextField value={productos.sgacanpicking} />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Cantidad Picking:</span>
              <CustomInputInteger
                InputProps={{
                  inputProps: {
                    min: 0,
                    max: productos.sgacanpicking,
                  },
                }}
                value={productos.cantidadSeleccionada}
                setValue={(newCantidad) => {
                  setCantidadPicking(newCantidad)

                  setProductosPicking((prevProductosPicking) =>
                    prevProductosPicking.map((producto) => {
                      if (
                        producto.sgapickingsecuen === productos.sgapickingsecuen &&
                        producto.artcodigo === productos.artcodigo
                      ) {
                        updateProduct(
                          productos.sgapickingsecuen,
                          productos.artcodigo,
                          {
                            cantidadSeleccionada: newCantidad, // Actualizar el campo cantidadSeleccionada
                          },
                          prevProductosPicking,
                        )
                        return {
                          ...producto,
                          cantidadSeleccionada: newCantidad,
                        }
                      }
                      return producto
                    }),
                  )
                }}
              />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Series Lote:</span>
              <Lotes
                maxCantidadEmbalaje={Number(productos.sgacanpicking)}
                setLotesInProducto={() => {}}
                artdiasseg={0}
                initialLotes={productos.lotes}
                cantidadLoteInitial={Number(productos.sgacanpicking)}
              />
            </div>
            <div style={styles.row}>
              <span style={styles.rowTitle}>Series/Lote:</span>

              <CustomSelectComponent lotesData={productos.lotes} style={styles.rowContainer} />
            </div>
            <div style={styles.row}>
              {productos.detalleAumento !== " " ? (
                // Mostrar la información de `producto.detalleAumento` cuando no está vacío
                <div style={styles.row}>
                  <span style={styles.rowTitle}>Aumento realizado por:</span>
                  <DisabledTextField value={productos.detalleAumento} />
                </div>
              ) : (
                // Mostrar el div con el input y el botón cuando `producto.detalleAumento` está vacío
                <div style={styles.rowContainer}>
                  <span style={styles.rowTitle}>Cantidad a Aumentar:</span>
                  <div style={styles.rowContainer}>
                    <CustomInputInteger
                      disabled={disabledAumentar}
                      value={cantidadAumentar}
                      setValue={setCantidadAumentar}
                    />
                    <Button
                      disabled={disabledAumentar}
                      type="submit"
                      variant="contained"
                      color="primary"
                      style={{ marginTop: "10px" }}
                      onClick={handleAumentarCantidad}
                    >
                      Aumentar
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </CustomFieldset>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

const VerProductosPickingComponent = () => {
  const location = useLocation() // Obtiene los datos de location.state
  const [productosPicking, setProductosPicking] = useState("")
  const { modifiedProducts, updateProduct } = useContext(PickingContext)
  const [invcodigo, setInvCodigo] = useState(0)
  const [bodcodigo, setBodCodigo] = useState("")
  const [bahias, setBahias] = useState("")
  const [niveles, setNiveles] = useState("")
  const [posiciones, setPosiciones] = useState("")
  const sgapicking = location.state.Picking
  const [searchTerm, setSearchTerm] = useState("")
  const debouncedSearchTerm = useDebounce(searchTerm, 500)
  const [comentarioPicking, setComentarioPicking] = useState("")
  const [fechaInicial, setFechaInicial] = useState(dayjs())

  const [infoGenerada, setInfoGenerada] = useState(null)
  const [openImpresion, setOpenImpresion] = useState(false)

  const navigate = useNavigate()

  const handleOpenDetalleImpresion = (data) => {
    setInfoGenerada(data)
    setOpenImpresion(true)
  }

  const handleCloseDetalleImpresion = () => {
    setOpenImpresion(false)
    navigate("/home/dashboard/picking")
  }

  const handleComentario = (event) => {
    setComentarioPicking(event.target.value)
  }

  const handleFechaInicial = (newFecha) => {
    setFechaInicial(newFecha)
  }

  useEffect(() => {
    // Solo actualizar si hay productos modificados
    if (modifiedProducts.length > 0) {
      // Actualizar productos solo si han sido modificados
      const updatedProducts = productosPicking.map((product) => {
        const modifiedProduct = modifiedProducts.find(
          (modified) =>
            modified.sgapickingsecuen === product.sgapickingsecuen && modified.artcodigo === product.artcodigo,
        )
        return modifiedProduct || product
      })

      // Comprobar si los productos realmente han cambiado
      const hasChanges = JSON.stringify(updatedProducts) !== JSON.stringify(productosPicking)

      if (hasChanges) {
        setProductosPicking(updatedProducts)
      }
    }
    console.log(modifiedProducts)
  }, [modifiedProducts, productosPicking])

  const crearPicking = useCallback(async () => {
    console.log(modifiedProducts)
    const options = {
      method: "POST",
      body: JSON.stringify({
        productos: modifiedProducts,
        comentarioPicking,
        sgapicking,
      }),
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    }

    let response = await fetchwrapper("/picking/guardarPicking", options)
    response = await response.json()
    return response
  }, [comentarioPicking, sgapicking, modifiedProducts])

  const handleCrearPicking = async () => {
    const productosConCantidadIncorrecta = modifiedProducts.filter((producto) => producto.cantidadSeleccionada <= 0)

    if (!comentarioPicking) {
      Swal.fire({
        icon: "error",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos obligatorios.",
      })
    } else if (productosConCantidadIncorrecta.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Cantidades incorrectas",
        text: `Existen productos con cantidad seleccionada igual o menor a 0. Verifica los productos antes de continuar.`,
      })
    } else {
      try {
        const response = await crearPicking()

        Swal.fire({
          icon: "success",
          title: "Operación exitosa",
          text: "Se grabó el Picking",
        }).then(() => {
          handleOpenDetalleImpresion(response.data)
        })
      } catch (error) {
        // Si ocurre un error en la solicitud (problemas de red, etc.)
        Swal.fire({
          icon: "error",
          title: "Error en la operación",
          text: "Ocurrió un error inesperado. Inténtalo nuevamente.",
        })
      }
    }
  }

  const setProducto = (sgapickingsecuen, artcodigo, newInfo) => {
    updateProduct(sgapickingsecuen, artcodigo, newInfo, productosPicking)
    setProductosPicking((prev) => {
      const newProductosPicking = prev.map((product) => {
        if (product?.sgapickingsecuen === sgapickingsecuen && product?.artcodigo === artcodigo) {
          return {
            ...product,
            bahcodigo: newInfo.bahcodigo !== undefined ? newInfo.bahcodigo : product.bahcodigo,
            bahdescripcion: newInfo.bahdescripcion !== undefined ? newInfo.bahdescripcion : product.bahdescripcion,
            izoncodigo: newInfo.izoncodigo !== undefined ? newInfo.izoncodigo : product.izoncodigo,
            izondescripcion: newInfo.izondescripcion !== undefined ? newInfo.izondescripcion : product.izondescripcion,
            pascodigo: newInfo.pascodigo !== undefined ? newInfo.pascodigo : product.pascodigo,
            pasdescripcion: newInfo.pasdescripcion !== undefined ? newInfo.pasdescripcion : product.pasdescripcion,
          }
        }
        return product
      })
      return newProductosPicking
    })
  }

  const setProductoAumento = (sgapickingsecuen, artcodigo, newInfo) => {
    updateProduct(sgapickingsecuen, artcodigo, newInfo, productosPicking)
    setProductosPicking((prev) => {
      const newProductosPicking = prev.map((product) => {
        if (product?.sgapickingsecuen === sgapickingsecuen && product?.artcodigo === artcodigo) {
          return {
            ...product,
            sgacanpicking: newInfo.sgacanpicking !== undefined ? newInfo.sgacanpicking : product.sgacanpicking,
            sgacansolfac: newInfo.sgacansolfac !== undefined ? newInfo.sgacansolfac : product.sgacansolfac,
          }
        }
        return product
      })
      return newProductosPicking
    })
  }

  const setProductoI = (sgapickingsecuen, artcodigo, newInfo) => {
    updateProduct(sgapickingsecuen, artcodigo, newInfo, productosPicking)

    const mapping = {
      bahcodigo: "bahcodigoI",
      bahdescripcion: "bahdescripcionI",
      izoncodigo: "izoncodigoI",
      izondescripcion: "izondescripcionI",
      pascodigo: "pascodigoI",
      pasdescripcion: "pasdescripcionI",
    }

    setProductosPicking((prev) => {
      const newProductosPicking = prev.map((product) => {
        if (product?.sgapickingsecuen === sgapickingsecuen && product?.artcodigo === artcodigo) {
          console.log("Producto encontrado:", product)
          const updatedProduct = { ...product }

          if (updatedProduct.bahias && updatedProduct.bahias[0]) {
            const updatedBahia = { ...updatedProduct.bahias[0] }

            Object.keys(mapping).forEach((key) => {
              if (newInfo[key] !== undefined) {
                updatedBahia[mapping[key]] = newInfo[key]
              }
            })

            updatedProduct.bahias[0] = updatedBahia
          }

          return updatedProduct
        }
        return product
      })
      return newProductosPicking
    })
  }

  const setProductoNiveles = (sgapickingsecuen, artcodigo, newInfo) => {
    updateProduct(sgapickingsecuen, artcodigo, newInfo, productosPicking)
    setProductosPicking((prev) => {
      const newProductosPicking = prev.map((product) => {
        if (product?.sgapickingsecuen === sgapickingsecuen && product?.artcodigo === artcodigo) {
          return {
            ...product,
            nivcodigo: newInfo.nivcodigo !== undefined ? newInfo.nivcodigo : product.nivcodigo,
            nivdescripcion: newInfo.nivdescripcion !== undefined ? newInfo.nivdescripcion : product.nivdescripcion,
          }
        }
        return product
      })
      return newProductosPicking
    })
  }

  const setProductoNivelesI = (sgapickingsecuen, artcodigo, newInfo) => {
    updateProduct(sgapickingsecuen, artcodigo, newInfo, productosPicking)
    setProductosPicking((prev) => {
      const newProductosPicking = prev.map((product) => {
        if (product?.sgapickingsecuen === sgapickingsecuen && product?.artcodigo === artcodigo) {
          return {
            ...product,
            // Verificamos que 'nivel' exista antes de intentar modificarlo
            nivel: {
              ...product.nivel,
              nivcodigoI: newInfo.nivcodigo !== undefined ? newInfo.nivcodigo : product.nivcodigoI,
              nivdescripcionI:
                newInfo.nivdescripcion !== undefined ? newInfo.nivdescripcion : product.nivel.nivdescripcionI,
            },
          }
        }
        return product
      })
      return newProductosPicking
    })
  }

  const setProductoPosiciones = (sgapickingsecuen, artcodigo, newInfo) => {
    updateProduct(sgapickingsecuen, artcodigo, newInfo, productosPicking)
    setProductosPicking((prev) => {
      const newProductosPicking = prev.map((product) => {
        if (product?.sgapickingsecuen === sgapickingsecuen && product?.artcodigo === artcodigo) {
          return {
            ...product,
            poscodigo: newInfo.poscodigo !== undefined ? newInfo.poscodigo : product.poscodigo,
            posdescripcion: newInfo.posdescripcion !== undefined ? newInfo.posdescripcion : product.posdescripcion,
          }
        }
        return product
      })
      return newProductosPicking
    })
  }

  const setProductoPosicionesI = (sgapickingsecuen, artcodigo, newInfo) => {
    updateProduct(sgapickingsecuen, artcodigo, newInfo, productosPicking)
    setProductosPicking((prev) => {
      const newProductosPicking = prev.map((product) => {
        if (product?.sgapickingsecuen === sgapickingsecuen && product?.artcodigo === artcodigo) {
          return {
            ...product,
            posiciones: {
              ...product.posiciones,
              poscodigoI: newInfo.poscodigo !== undefined ? newInfo.poscodigo : product.posiciones?.poscodigoI,
              posdescripcionI:
                newInfo.posdescripcion !== undefined ? newInfo.posdescripcion : product.posiciones?.posdescripcionI,
            },
          }
        }
        return product
      })
      return newProductosPicking
    })
  }

  const [page, setPage] = useState(1) // Estado para la página actual
  const limit = 10 // Definir el límite de elementos por página

  const {
    data: fetchedPickingSugerido = {},
    isError: isLoadingPickingSugeridoError,
    isFetching: isFetchinPickingSugerido,
    isLoading: isLoadingPickingSugerido,
    refetch: refetchPickingSugerido,
  } = useGetPickingSugerido(page)

  function useGetPickingSugerido() {
    return useQuery({
      queryKey: ["PickingSugeridoDetalle", page, limit, debouncedSearchTerm],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({ limit, page, sgapicking, searchTerm: debouncedSearchTerm }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper(`/picking/getDetallePickingSugerido`, options)
        response = await response.json()
        return response
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: true,
    })
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value)
    setPage(1)

    if (e.target.value === "") {
      setPage(1)
    }
  }

  useEffect(() => {
    if (fetchedPickingSugerido.data && fetchedPickingSugerido.data.length > 0) {
      setProductosPicking(fetchedPickingSugerido.data)
      setNiveles(fetchedNiveles)
      setPosiciones(fetchedPosiciones)
      const firstProducto = fetchedPickingSugerido.data[0]
      if (firstProducto.invcodigo !== invcodigo || firstProducto.bodcodigo !== bodcodigo) {
        setInvCodigo(firstProducto.invcodigo)
        setBodCodigo(firstProducto.bodcodigo)
      }
    }
  }, [fetchedPickingSugerido.data])

  const {
    data: fetchedBahias = [],
    isError: isLoadingBahiasError,
    isFetching: isFetchingBahias,
    isLoading: isLoadingBahias,
    refetch: refetchBahias,
    error: isFetchingBahiasError,
  } = useGetBahias()

  // READ hook (get Bahias from api)
  function useGetBahias() {
    return useQuery({
      queryKey: ["BahiasCreatePicking", invcodigo, bodcodigo],

      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({ invcodigo, bodcodigo }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper(`/picking/getBahiasHelper`, options)
        response = await response.json()
        return response?.data ?? []
      },
      refetchOnWindowFocus: false,
      enabled: false,
    })
  }

  const {
    data: fetchedNiveles = [],
    isError: isLoadingNivelesError,
    isFetching: isFetchingNiveles,
    isLoading: isLoadingNiveles,
    refetch: refetchNiveles,
    error: isFetchingNivelesError,
  } = useGetNiveles()

  // READ hook (get Niveles from api)
  function useGetNiveles() {
    return useQuery({
      queryKey: ["NivelesCreatePicking"],

      queryFn: async () => {
        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper(`/picking/getNiveles`, options)
        response = await response.json()
        return response?.data ?? []
      },
      refetchOnWindowFocus: false,
      enabled: true,
    })
  }

  const {
    data: fetchedPosiciones = [],
    isError: isLoadingPosicionesError,
    isFetching: isFetchingPosiciones,
    isLoading: isLoadingPosiciones,
    refetch: refetchPosiciones,
    error: isFetchingPosicionesError,
  } = useGetPosiciones()

  // READ hook (get Posiciones from api)
  function useGetPosiciones() {
    return useQuery({
      queryKey: ["PosicionesCreatePicking"],

      queryFn: async () => {
        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper(`/picking/getPosiciones`, options)
        response = await response.json()
        return response?.data ?? []
      },
      refetchOnWindowFocus: false,
      enabled: true,
    })
  }

  useEffect(() => {
    if (invcodigo !== 0 && bodcodigo !== "") {
      refetchBahias()
    }
  }, [invcodigo])

  useEffect(() => {
    if (fetchedBahias && fetchedBahias.length > 0) {
      setBahias(fetchedBahias)
    }
  }, [fetchedBahias])

  const handlePageChange = (event, value) => {
    setPage(value)
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <BackIcon />
        </div>
        <CustomTooltip title={"Grabar Picking"}>
          <Button onClick={handleCrearPicking}>
            <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
          </Button>
        </CustomTooltip>
        {openImpresion ? (
          <DetalleImpresion
            open={openImpresion}
            handleClose={handleCloseDetalleImpresion}
            infoGenerada={infoGenerada || {}}
          />
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 30px 30px 30px",
                fontSize: "25px",
              }}
            >
              <b>Crear Picking</b>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "space-around",
                padding: "20px",
                border: "1px solid #ddd",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                marginBottom: "2%",
              }}
            >
              <div style={{ backgroundColor: "#196C87", width: "100%", marginBottom: "2%" }}>
                <h2
                  style={{
                    color: "white",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  Detalles del Picking
                </h2>
              </div>

              <p>
                <b>Código del Picking:</b> {location.state.Picking}
              </p>
              <p>
                <b>Fecha de Emisión:</b> {normalFormatDate(location.state.Fecha_Emision)}
              </p>
              <p>
                <b>Hora de Emisión:</b> {location.state.Hora_Emision}
              </p>
              <p>
                <b>Cliente:</b>{" "}
                {fetchedPickingSugerido.data && fetchedPickingSugerido.data.length > 0 ? (
                  fetchedPickingSugerido.data[0].clinombre
                ) : (
                  <p>No hay datos de picking disponibles.</p>
                )}
              </p>
            </div>
            <div>
              <InputLabel>Comentario:</InputLabel>
              <TextField value={comentarioPicking} onChange={handleComentario} placeholder="" fullWidth />
            </div>
            <TextField
              variant="outlined"
              placeholder="Buscar producto..."
              fullWidth
              value={searchTerm}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              style={{ marginBottom: "20px" }}
            />
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              {productosPicking && productosPicking.length > 0 ? (
                productosPicking
                  .filter((producto) => producto.artdescri.toLowerCase().includes(searchTerm.toLowerCase()))
                  .map((productos) => (
                    <CustomAccordion
                      key={`${productos.artcodigo}-${productos.sgapickingsecuen}`}
                      updateProduct={updateProduct}
                      setProductosPicking={setProductosPicking}
                      productos={productos}
                      fetchedBahias={bahias}
                      fetchedNiveles={niveles}
                      fetchedPosiciones={posiciones}
                      setProductoNiveles={setProductoNiveles}
                      setProductoPosiciones={setProductoPosiciones}
                      setProducto={setProducto}
                      setProductoI={setProductoI}
                      setProductoNivelesI={setProductoNivelesI}
                      setProductoPosicionesI={setProductoPosicionesI}
                    />
                  ))
              ) : (
                <p>No hay datos de picking disponibles.</p>
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
              <Pagination
                count={Math.ceil(fetchedPickingSugerido.total_count / limit)}
                page={page}
                onChange={handlePageChange}
              />
            </div>
          </>
        )}
      </div>
    </ThemeProvider>
  )
}

export default VerProductosPickingComponent
